// Skeleton placeholder rendered during the first fetch. Layout matches the
// real OverviewGrid so the swap-in does not cause layout shift (Lighthouse
// CLS < 0.1 per TASK-030 AC).

import { cn } from "@shared/lib";

export interface OverviewSkeletonProps {
  loadingLabel: string;
  className?: string;
}

function pulse(className: string): string {
  return cn("animate-pulse rounded-md bg-muted", className);
}

export function OverviewSkeleton({
  loadingLabel,
  className,
}: OverviewSkeletonProps) {
  return (
    <div
      className={cn("flex flex-col gap-6", className)}
      role="status"
      aria-live="polite"
      aria-label={loadingLabel}
    >
      {/* Hero gauge — same 160px circle footprint as HealthGauge. */}
      <div className="flex justify-center">
        <div className={pulse("h-40 w-40 rounded-full")} />
      </div>
      {/* 4 metric cards — same 4-up grid as the real grid. */}
      <div className="grid grid-cols-2 gap-3">
        <div className={pulse("h-24")} />
        <div className={pulse("h-24")} />
        <div className={pulse("h-24")} />
        <div className={pulse("h-24")} />
      </div>
      {/* Activity chart placeholder — height parity with ActivityChart's 200px. */}
      <div className={pulse("h-[200px]")} />
      {/* Top posts list — 5 rows. */}
      <div className="flex flex-col gap-2">
        <div className={pulse("h-14")} />
        <div className={pulse("h-14")} />
        <div className={pulse("h-14")} />
        <div className={pulse("h-14")} />
        <div className={pulse("h-14")} />
      </div>
    </div>
  );
}
